if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');      
      if (this.form) {
        const idInput = this.form.querySelector('[name=id]');
        if (idInput) idInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      }
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer') && this.submitButton) {
        this.submitButton.setAttribute('aria-haspopup', 'dialog');
      }
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton && this.submitButton.getAttribute('aria-disabled') === 'true') return;

      const formId = this.form ? this.form.id : null;
      const customForm = this.querySelector('custom-measurement-form') || 
                         (formId ? document.querySelector(`custom-measurement-form[data-product-form-id="${formId}"]`) : null) || 
                         document.querySelector(`custom-measurement-form[data-section-id="${this.dataset.section || ''}"]`) || 
                         document.querySelector('custom-measurement-form');

      if (customForm && typeof customForm.validateCustomMeasurements === 'function') {
        const validation = customForm.validateCustomMeasurements(true);
        if (!validation.valid) {
          return;
        }
      }

      this.handleErrorMessage();

      if (this.submitButton) {
        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
      }
      const spinner = this.querySelector('.loading-overlay__spinner');
      if (spinner) spinner.classList.remove('hidden');

      const config = typeof fetchConfig === 'function' ? fetchConfig('javascript') : {
        method: 'POST',
        headers: {
          'Accept': 'application/javascript',
          'X-Requested-With': 'XMLHttpRequest'
        }
      };
      config.headers = config.headers || {};
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      if (!this.form) return;
      const formData = new FormData(this.form);

      // Collect and attach Custom Tailored / Custom Size measurement properties to cart payload
      if (customForm) {
        const propertyInputs = customForm.querySelectorAll('.custom-measurement-input');
        propertyInputs.forEach((input) => {
          const propName = input.dataset.propertyName;
          let val = input.value ? input.value.trim() : '';
          if (val.length > 0 && !isNaN(parseFloat(val))) {
            if (!/(\bin|\binches|in\.|"|cm)$/i.test(val)) {
              val = `${val} in`;
            }
            formData.set(`properties[${propName}]`, val);
          } else {
            formData.delete(`properties[${propName}]`);
          }
        });
      }

      if (this.dataset.cartType != 'page' && this.cart) {
        if (typeof this.cart.getSectionsToRender === 'function') {
          formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        }
        formData.append('sections_url', window.location.pathname);
        if (typeof this.cart.setActiveElement === 'function') {
          this.cart.setActiveElement(document.activeElement);
        }
      }
      config.body = formData;

      const cartAddUrl = (window.routes && window.routes.cart_add_url) ? window.routes.cart_add_url : '/cart/add.js';

      fetch(`${cartAddUrl}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton ? this.submitButton.querySelector('.sold-out-message') : null;
            if (!soldOutMessage) return;
            if (this.submitButton) {
              this.submitButton.setAttribute('aria-disabled', true);
              const textSpan = this.submitButton.querySelector('span');
              if (textSpan) textSpan.classList.add('hidden');
            }
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (this.dataset.cartType == 'page') {
            window.location = (window.routes && window.routes.cart_url) ? window.routes.cart_url : '/cart';
            return;
          }

          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { if (this.cart && typeof this.cart.renderContents === 'function') this.cart.renderContents(response); });
            }, { once: true });
            quickAddModal.hide(true);
          } else if (this.cart && typeof this.cart.renderContents === 'function') {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          if (this.submitButton) {
            this.submitButton.classList.remove('loading');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          }
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          const spinner = this.querySelector('.loading-overlay__spinner');
          if (spinner) spinner.classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage && this.errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}

if (typeof $ !== 'undefined' && typeof $(document).ajaxComplete === 'function') {
  $(document).ajaxComplete(function() {
   // CartJS.updateCart();
  });
}
